/**
 * /knowledge · M09 Knowledge 管理（S3 Day13）
 */
import { M09Shell } from "@/components/m09/m09-shell";
import { PageHeader, type PageHelp } from "@/components/shared/page-help";
import { createFileRoute, useRouterState } from "@tanstack/react-router";

export const Route = createFileRoute("/knowledge")({
	component: KnowledgeRoute,
});

function KnowledgeRoute() {
	const hash = useRouterState({ select: (s) => s.location.hash });
	const view = getKnowledgeView(hash);
	const copy = KNOWLEDGE_VIEW_COPY[view];

	return (
		<div className="space-y-4">
			<PageHeader title={copy.title} description={copy.description} help={copy.help} />
			<M09Shell view={view} />
		</div>
	);
}

type KnowledgeView = "sources" | "search-verify";

function getKnowledgeView(hash: string): KnowledgeView {
	return hash === "knowledge-search-verify" ? "search-verify" : "sources";
}

const knowledgeHelpSections: PageHelp["sections"] = [
	{
		title: "状态怎么理解",
		items: [
			"本地沙盒表示当前用前端/本地测试数据验证检索体验。",
			"向量检索表示真实 Qdrant/RAG runtime 已接入。",
			"未配置表示依赖还没接好，不应把空结果当作知识缺失。",
		],
	},
	{
		title: "验证方式",
		items: [
			"新增或更新文档后，先跑检索沙盒看命中片段。",
			"命中率异常时，回到文档分类、关键词和索引状态排查。",
		],
	},
];

const KNOWLEDGE_VIEW_COPY: Record<
	KnowledgeView,
	{ title: string; description: string; help: PageHelp }
> = {
	sources: {
		title: "知识源",
		description: "维护政策、FAQ 和商品知识，确认入库、索引和来源状态。",
		help: {
			title: "知识源说明",
			description: "这里用于管理回复时可引用的知识文档，并确认它们是否已经入库。",
			sections: knowledgeHelpSections,
		},
	},
	"search-verify": {
		title: "检索与验证",
		description: "用模拟问题检查知识召回、命中片段和证据是否足够支撑回复。",
		help: {
			title: "检索与验证说明",
			description: "这里用于验证检索是否能找到正确证据，不把空结果直接当成业务知识缺失。",
			sections: knowledgeHelpSections,
		},
	},
};
